import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import { sidebarItemsActions } from './redux/actions/sidebarItemsAction'
//const devTools =
//  process.env.NODE_ENV === "production"
//    ? applyMiddleware(thunk, save())
//    : composeWithDevTools(applyMiddleware(thunk, save({ namespace: "SAMSV2" })));

//const store = createStore(
//  rootReducer,
//  load(),
//  devTools
//);
var st = store.getState();
if (st.token.token !== "") {
  store.dispatch(sidebarItemsActions.getSidebarItems());
  console.log(" getsidebaritems from index")
}
//require('dotenv').config();

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <App />
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
